import { Box, styled } from '@mui/material';

export const ProfileNavItemContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1, 3, 1, 2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: `${theme.shape.borderRadius * 3.2}px`,
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  columnGap: theme.spacing(2),
  '& svg': {
    fill: theme.palette.primary.main,
    width: '24px',
    height: '24px',
  },
}));
